import { Box } from "@mui/material";
import { DotLegalButton, DotLegalHeader, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { publicRiskObservationStyles as styles } from "../PublicRiskObservation.styles";

export interface IReporterStepProps {
    observedBy: string;
    observedByEmail: string;
    observedByErrorText?: string;
    observedByEmailErrorText?: string;
    hasRememberedReporter: boolean;
    isSubmitting: boolean;
    onObservedByChange: (observedBy: string) => void;
    onObservedByEmailChange: (observedByEmail: string) => void;
    onBack: () => void;
    onSubmit: () => void;
}

function ReporterStep(props: IReporterStepProps) {
    const { translateString } = useTranslation();

    return (
        <>
            <Box sx={styles.content}>
                <DotLegalHeader headerStyle="extraLarge" marginBottom={0}>
                    {translateString("reportObservationReporterHeader")}
                </DotLegalHeader>
                <DotLegalHeader headerStyle="small" fontWeight={400} marginBottom={0}>
                    {translateString("reportObservationReporterText")}
                </DotLegalHeader>
                <Box sx={styles.fieldGroup}>
                    <DotLegalTextField
                        debounce={false}
                        label={translateString("name")}
                        placeholder={translateString("name")}
                        value={props.observedBy}
                        onChange={props.onObservedByChange}
                        errorText={props.observedByErrorText}
                        onEnterPressed={props.onSubmit}
                        autoFocus
                        noMargin
                    />
                    <DotLegalTextField
                        debounce={false}
                        label={translateString("email")}
                        placeholder={translateString("reportObservationReporterEmailPlaceholder")}
                        value={props.observedByEmail}
                        onChange={props.onObservedByEmailChange}
                        errorText={props.observedByEmailErrorText}
                        onEnterPressed={props.onSubmit}
                        noMargin
                        slotProps={{ htmlInput: { type: "email", inputMode: "email", autoComplete: "email" } }}
                    />
                </Box>
            </Box>
            <Box sx={styles.footer}>
                <DotLegalButton buttonType="secondary" size="medium" onClick={props.onBack}>
                    {translateString("previous")}
                </DotLegalButton>
                <Box sx={styles.footerPrimary}>
                    <DotLegalButton buttonType="primary" size="medium" fullWidth isLoading={props.isSubmitting} onClick={props.onSubmit}>
                        {translateString("reportObservationSubmit")}
                    </DotLegalButton>
                </Box>
            </Box>
        </>
    );
}

export default ReporterStep;
